var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide-fade"}},[(_vm.isShow)?_c('div',{staticClass:"page-component-up",on:{"click":_vm.getTop}},[_c('img',{attrs:{"src":require("../assets/images/images/top.png"),"alt":""}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }